import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { createZepetoImageMonitor } from '@/shared/utils/zepetoImageMonitor';
import { Chip } from '@/ui_v3';
import { cn } from '@/utils/tailwind.util';
import { GradientMask } from './GradientMask';
import { type NewMapBannerSize } from './NewMapBanner';
const SIZE_STYLES = {
  sm: {
    image: 'h-[66px] w-[104px]',
    object: 'w-[40px] h-[40px] left-[64px] top-[-15px]',
    height: 66,
    dimensions: {
      width: 104,
      height: 66,
      objectSize: 40
    }
  },
  md: {
    image: 'h-[90px] w-[104px]',
    object: 'w-[60px] h-[60px] left-[58px] top-[-22px]',
    height: 90,
    dimensions: {
      width: 104,
      height: 90,
      objectSize: 60
    }
  }
} as const;
export const ImageSection = ({
  mainImage,
  decorationImage,
  backgroundColor,
  size
}: {
  mainImage: string;
  decorationImage: string;
  backgroundColor: string;
  size: NewMapBannerSize;
}) => {
  const {
    t
  } = useTranslation(['common']);
  const sizeStyles = SIZE_STYLES[size];
  return <div className={cn('relative h-full w-[104px] shrink-0 rounded-l-md outline outline-[1px] outline-opacity-black-1 outline-offset-[-1px]', size === 'sm' && 'rounded-l-sm')} data-sentry-component="ImageSection" data-sentry-source-file="ImageSection.tsx">
      <Chip rounded="full" size="sm" className="absolute left-[10px] top-[-8px] border-opacity-black-3 bg-yellow-400 text-default" data-sentry-element="Chip" data-sentry-source-file="ImageSection.tsx">
        {t('common.banner.newMap')}
      </Chip>
      <Image src={mainImage} alt="New Map Banner Image" className={cn('rounded-l-md object-cover', size === 'sm' && 'rounded-l-sm', sizeStyles.image)} width={sizeStyles.dimensions.width} height={sizeStyles.dimensions.height} {...createZepetoImageMonitor('new-map-banner')} data-sentry-element="Image" data-sentry-source-file="ImageSection.tsx" />
      <Image src={decorationImage} alt="New Map Banner Object Image" className={cn('absolute z-20', sizeStyles.object)} width={sizeStyles.dimensions.objectSize} height={sizeStyles.dimensions.objectSize} data-sentry-element="Image" data-sentry-source-file="ImageSection.tsx" />
      <GradientMask backgroundColor={backgroundColor} height={sizeStyles.height} className="absolute bottom-0 right-[-0.5px] top-0" data-sentry-element="GradientMask" data-sentry-source-file="ImageSection.tsx" />
    </div>;
};